import { clearStorage } from "@/utils/storage/protectedStorage";

import type { IAuthSlice } from "@/types/auth.interface";
import { createSlice } from "@reduxjs/toolkit";

const initialState: IAuthSlice = {
  networkProvider: "testnet",
  loginToken: "",
  loginPopup: false,
  loginData: null,
  verificationData: null,
  authModal: false,
  authMode: "login",
};
export const AUTH_SLICE_NAME = "auth";

const authSlice = createSlice({
  name: AUTH_SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
    setLogout: (state) => {
      clearStorage();
      localStorage.removeItem("valuesOfRememberMe");
      return {
        ...state,
        networkProvider: "testnet",
        refreshToken: "",
        loginToken: "",
      };
    },
  },
});

export const { setLogout, reset } = authSlice.actions;

export default authSlice.reducer;
